import Substance from './Substance';
import { SUBSTANCE_CATEGORIES } from '../constants/effects';

/**
 * A ready-made compound such as water. Its symbol is the chemical formula.
 */
export default class Compound extends Substance {
  constructor({ id, formula, plainFormula, ...rest }) {
    super({ id, symbol: formula, category: SUBSTANCE_CATEGORIES.COMPOUND, ...rest });
    this.formula = formula;
    // Formula without subscript characters, used when balancing equations.
    this.plainFormula = plainFormula;
  }
}
